module.exports = new __parcel__URL__("die-mensch-maschine.3733a4aa.jpg").toString();